// extracted by mini-css-extract-plugin
module.exports = {"contactCard":"ContactCard_contactCard__LOEl7"};